'use client';

import dynamic from 'next/dynamic';
import { useInView } from 'react-intersection-observer';

const LocationSection = dynamic(() => import('./LocationSection'), {
  ssr: false,
});

export default function LazyLocationSection() {
  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin: '400px 0px',
  });

  return <div ref={ref}>{inView && <LocationSection />}</div>;
}
